<template>
  <form
    ref="form"
    class="language-switch"
  >
    <FormSection
      :title="title"
      appearance="form-section-inline"
    >
      <DropdownSelect
        class="language-switch__select"
        :value="lang"
        :options="options"
        no-auto-size
        full-width
        name="locale"
        @input="onSelectChange"
      />
    </FormSection>
  </form>
</template>

<script>
import DropdownSelect from 'src/components/form/DropdownSelect/DropdownSelect.vue';
import FormSection from 'src/components/form/FormSection/FormSection.vue';

export default {
  name: 'LanguageSwitch',
  components: { DropdownSelect, FormSection },
  props: {
    lang: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  methods: {
    onSelectChange() {
      setTimeout(() => {
        this.$refs.form.submit();
      });
    }
  },
  computed: {
    options() {
      return [
        { title: 'Русский', value: 'ru' },
        { title: 'English', value: 'en' },
      ];
    },
  }
};
</script>
